
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info } from 'lucide-react';

export function VariablesInfo() {
  return (
    <Alert className="bg-blue-50 border-blue-200 mb-6">
      <Info className="h-4 w-4 text-blue-600" />
      <AlertTitle className="text-blue-800">Using Variables</AlertTitle>
      <AlertDescription className="text-blue-700">
        Email templates support variables in the format <code className="p-0.5 bg-blue-100 rounded">&#123;&#123;variableName&#125;&#125;</code>. 
        These will be replaced with actual data when the email is sent.
      </AlertDescription>
    </Alert>
  );
}
